import { connect } from 'react-redux';
import { withFormik } from 'formik';
import { compose } from 'redux';
import { toast } from 'react-toastify';

import validationSchema from './ChangePassword.validation';
import { formValuesToAPI } from './ChangePassword.mapper';
import { getErrorMessage } from '../../../utils/utilities';

import {
  changePassword,
  updateProfile,
  updateJwt,
  updateCompanyPaymentType
} from '../../../actions/authentication';

import storage from '../../../api/localStorage';

const intialValues = {
  newPassword: '',
  confirmNewPassword: ''
};

const mapStateToProps = (state) => {
  return {
    profile: state.profile
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (data) => dispatch(changePassword(data)),
    updateJwt: (data) => dispatch(updateJwt(data, 'company')),
    updateCompanyPaymentType: (data) => dispatch(updateCompanyPaymentType(data)),
    updateProfile: (data) => dispatch(updateProfile(data))
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFormik({
    mapPropsToValues: () => intialValues,
    validationSchema,
    handleSubmit: (values, { setStatus, setSubmitting, props }) => {
      props
        ?.changePassword(formValuesToAPI(props, values))
        .then((response) => {
          toast.info('Password changed successfully.');
          storage.setToken(response.data.data.loginToken, 'company');
          props.history.push('/dashboard');
          setSubmitting(false);
        })
        .catch((error) => {
          setSubmitting(false);
          toast.error(getErrorMessage(error));
        });
    },
    displayName: 'LoginForm'
  })
);
